import axios from 'axios'
import { host } from '../config/env'

//
export const getLimitInfo = (product) => {
  return axios({
    baseURL: host.mall,
    url: '/api/m/order/limit',
    method: 'post'
  })
}

// 获取用户信息
export const getProductInfo = (product) => {
  return axios({
    baseURL: host.mall,
    method: 'get',
    url: `/api/product/${product.id}`
  })
}

// 新支付验签
export const asyncOrderCallback = (data) => {
  return axios({
    baseURL: host.mall,
    method: 'post',
    url: '/api/m/asyncOrderCallback/callback',
    headers: {
      'content-type': 'application/x-www-form-urlencoded; charset=UTF-8'
    },
    data
  })
}

/**
   * 订单保存商城回调
   * @param data
   * @returns {Promise<AxiosResponse<T>>}
   */
export const getOrderStatus = data => {
  return axios({
    baseURL: host.mall,
    method: 'post',
    url: '/api/m/asyncOrderCallback/isOrderCallbackSuccessById',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    },
    data
  })
}

/**
 * 最新购买会员的30条用户相关信息
 *
 */
export const latestBuyMemberRecord = () => {
  return axios({
    baseURL: host.morder,
    method: 'get',
    url: '/api/m/member/last-user'
  })
}

/**
 * 获取商品列表
 *
 */
export const getGoodsList = (type) => {
  return new Promise((resolve) => {
    axios({
      baseURL: host.mp1,
      method: 'get',
      url: `/m/goods/list?type=${type}`
    }).then(({ data }) => {
      resolve(data)
    }).catch(() => {
      resolve({})
    })
  })
}

/**
   * 获取签名
   */
export const getProductSign = data => {
  return axios({
    baseURL: host.mall,
    method: 'post',
    url: '/api/m/order/productSign',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8'
    },
    data
  })
}

/**
 * 获取权益商品列表
 *
 */
export const getBenefitGoodsList = (type) => {
  return new Promise((resolve) => {
    axios({
      baseURL: host.mtopic,
      method: 'get',
      url: `/m/topic/config/findGoodsByType?type=${type}`
    }).then(({ data }) => {
      resolve(data)
    }).catch(() => {
      resolve({})
    })
  })
}
